// import {KTSVG} from '../../../../../../../_metronic/helpers'
// import {useMutation, useQueryClient} from 'react-query'
// import {updateUser} from '../../core/_requests'
// import {QUERIES} from '../../../../../../../_metronic/helpers'
// import {useQueryResponse} from '../../core/QueryResponseProvider'
// import {successToast} from '../../../../../../../_metronic/helpers/components/Toaster'
// import {useLocation} from 'react-router-dom'
// import {useEffect, useState} from 'react'

// const UserConfirmationDelete = ({id, data, close}: any) => {
//   const queryClient = useQueryClient()
//   const {query} = useQueryResponse()
//   const {pathname} = useLocation()
//   const payload = {
//     ...data,
//     status: 'INACTIVE',
//   }
//   const [showToastMsg, setShowToastMsg] = useState(false)
//   useEffect(() => {
//     if (showToastMsg) {
//       successToast('Deleted')
//     }
//   }, [showToastMsg])

//   // const deleteItem = useMutation(
//   //   () =>
//   //     updateUser(
//   //       payload,
//   //       pathname.includes('apps/settings/content')
//   //         ? `content/update/${data.id}`
//   //         : `categories/${data.id}/update`
//   //     ),
//   //   {
//   //     // 💡 response of the mutation is passed to onSuccess
//   //     onSuccess: () => {
//   //       // ✅ update detail view directly
//   //       queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
//   //       successToast('Deleted')
//   //       setShowToastMsg(true)
//   //       close()
//   //     },
//   //   }
//   // )





//   const deleteItem = useMutation(
//     () => updateUser({}, `user/${data.id}/status?status=INACTIVE&type=${data.userType || 'RECYCLER'}`),
//     {
//       // 💡 response of the mutation is passed to onSuccess
//       onSuccess: () => {
//         // ✅ update detail view directly
//         queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
//         successToast('Deleted')
//         setShowToastMsg(true)
//         close()
//       },
//     }
//   )


//   return (
//     <>
//       <div className='modal fade show d-block' role='dialog' tabIndex={-1} aria-modal='true'>
//         <div
//           className={`modal-dialog 
//          mw-650px modal-dialog-centered`}
//         >
//           <div className='modal-content'>
//             <div className='modal-header'>
//               <h5 className='modal-title'>Confirmation</h5>
//               <div
//                 className='btn btn-icon btn-sm btn-active-light-primary ms-2'
//                 data-bs-dismiss='modal'
//                 aria-label='Close'
//                 onClick={close}
//               >
//                 <KTSVG
//                   path='/media/icons/duotune/arrows/arr061.svg'
//                   className='svg-icon svg-icon-2x'
//                 />
//               </div>
//             </div>
//             <div id='kt_modal_add_user' className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
//               {/* <div className='text-center flex justify-center'>
//                 Are you sure you want to delete ?
//               </div> */}
//               <div className='text-center flex justify-center'>
//                 {pathname.includes('/apps/business/recycler') ? (
//                   <div>
//                     <div>This user can not login anymore once deleted</div>
//                     <div>Are you sure you want to delete this user ?</div>
//                   </div>
//                 ) : (
//                   'Are you sure you want to delete ?'
//                 )}
//               </div>
//               <div style={{textAlign: 'center'}}>
//                 <br />
//               </div>
//             </div>
//             <div className='modal-footer'>
//               <button
//                 type='reset'
//                 onClick={() => close()}
//                 className='btn btn-light me-3'
//                 data-kt-users-modal-action='cancel'
//                 // disabled={formik.isSubmitting || isUserLoading}
//               >
//                 No
//               </button>
//               <button
//                 onClick={async () => {
//                   await deleteItem.mutateAsync()
//                 }}
//                 type='submit'
//                 className='btn btn-danger'
//                 data-kt-users-modal-action='submit'
//                 style={{backgroundColor: '#333333'}}
//               >
//                 <span className='indicator-label'>Yes</span>
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className='modal-backdrop fade show'></div>
//     </>
//   )
// }

// export {UserConfirmationDelete}




import axios from 'axios'
import { KTSVG } from '../../../../../../../_metronic/helpers'
import { useMutation, useQueryClient } from 'react-query'
import { updateUser } from '../../core/_requests'
import { QUERIES } from '../../../../../../../_metronic/helpers'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { successToast } from '../../../../../../../_metronic/helpers/components/Toaster'
import { useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'

const UserConfirmationDelete = ({ id, data, close }: any) => {
  const queryClient = useQueryClient()
  const { query } = useQueryResponse()
  const { pathname } = useLocation()
  const [showToastMsg, setShowToastMsg] = useState(false)

  console.log("dataaa", data)

  // Check if user is currently inactive
  const isInactive = data.status === 'INACTIVE'
  const newStatus = isInactive ? 'ACTIVE' : 'INACTIVE'
  const actionText = isInactive ? 'activate' : 'deactivate'

  useEffect(() => {
    if (showToastMsg) {
      successToast(isInactive ? 'Activated' : 'Deactivated')
    }
  }, [showToastMsg, isInactive])

  const deleteItem = useMutation(
    () => updateUser({}, `user/${data.id}/status?status=${newStatus}&type=${data.userType || 'RECYCLER'}`),
    {
      // 💡 response of the mutation is passed to onSuccess
      onSuccess: () => {
        // ✅ update detail view directly
        queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
        successToast(isInactive ? 'Activated' : 'Deactivated')
        setShowToastMsg(true)
        close()
      },
    }
  )
  const deletePOItem = async () => {
    const api = pathname.includes('apps/textile/textile-order-approval') ? `https://pfc-backend-api.asmglobal.co.in/v1/api/transactions/${data?.id}`
      : `https://pfc-backend-api.asmglobal.co.in/v1/api/txn-sale-order/${data?.id}`
    try {
      await axios.delete(api)
      queryClient.invalidateQueries([`${QUERIES.USERS_LIST}-${query}`])
      successToast('Deleted')
      close()
    } catch (error) {
      console.error('Error deleting PO item:', error)
    }
  }
  return (
    <>
      <div className='modal fade show d-block' role='dialog' tabIndex={-1} aria-modal='true'>
        <div
          className={`modal-dialog 
         mw-650px modal-dialog-centered`}
        >
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>Confirmation</h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
                onClick={close}
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div id='kt_modal_add_user' className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
              <div className='text-center flex justify-center'>
                {isInactive ? (
                  // Message for activating user
                  pathname.includes('/apps/business/recycler') ? (
                    <div>
                      <div>This user will be able to login again once activated</div>
                      <div>Are you sure you want to activate this user?</div>
                    </div>
                  ) : (
                    'Are you sure you want to activate this user?'
                  )
                ) : (
                  // Message for deactivating user
                  pathname.includes('/apps/business/recycler') ? (
                    <div>
                      <div>This user can not login anymore once deactivated</div>
                      <div>Are you sure you want to deactivate this user?</div>
                    </div>
                  ) : pathname.includes('apps/textile/textile-order-approval') ?
                    `Are you  sure want to  delete the transaction ID- ${data?.transactionId}`
                    : pathname.includes('apps/textile/textile-sale-order') ? (
                      `Are you  sure want to  delete the sale order ID- ${data?.saleOrderId}`
                    ) : (
                      'Are you sure you want to deactivate this user?'
                    )
                )}
              </div>
              <div style={{ textAlign: 'center' }}>
                <br />
              </div>
            </div>
            <div className='modal-footer'>
              <button
                type='reset'
                onClick={() => close()}
                className='btn btn-light me-3'
                data-kt-users-modal-action='cancel'
              >
                No
              </button>
              <button
                onClick={async () => {
                  (pathname.includes('apps/textile/textile-order-approval') || pathname.includes('apps/textile/textile-sale-order')) ? deletePOItem() : await deleteItem.mutateAsync()
                }}
                type='submit'
                className={`btn ${isInactive ? 'btn-success' : 'btn-danger'}`}
                data-kt-users-modal-action='submit'
                style={{ backgroundColor: isInactive ? '#50cd89' : '#333333' }}
              >
                <span className='indicator-label'>Yes</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export { UserConfirmationDelete }